import React from 'react'
import { AdminProcessMovementViewModel } from './AdminProcessMovementViewModel';
import { NavBarComponente } from '../../Components/NavBarComponente';
import { Container, Row, Image, Col, Form, Button } from 'react-bootstrap';
import fechar from '../../Imagens/close-24.png'; 
import salvar from '../../Imagens/save-16.png'; 

import "../../Estilo/Form.css";
import Select from 'react-select';
import { FormEvent } from '../../ScreenGeneric/Models/FormEvent';
import { ToastContainer, toast } from 'react-toastify';
import { LoaderComponente } from "../../Components/LoaderComponente";
import moment from 'moment';

interface MyProps {
    navigation: any
    delegate: AdminProcessMovementViewControllerDelegate
    viewModel: AdminProcessMovementViewModel
    idPrimary: number
    idAdminProcess: number
}

export interface AdminProcessMovementViewControllerDelegate {
    tapDimiss(navigation: any): void
}

export class AdminProcessMovementViewController extends React.Component<MyProps> implements AdminProcessMovementViewControllerDelegate {

    private formEvent: FormEvent
    state = {
        isLoading: false,
        json: {},
        professional: Array<any>()
    }

	constructor(props: any) {
        super(props)
        this.formEvent = new FormEvent(this)
    }
    
    tapDimiss(navigation: any): void {
        this.setState({
            showAddPerson: false
        })
    }

    componentDidMount() {
        this.setKeyFK()
        this.loadProfessional()
        if(this.props.idPrimary > 0) {
            this.loadStruct()
        }
    }

    render() {
        var json = this.state.json as any
        return (
            <div>
                <NavBarComponente propNav={this.props.navigation}/>
                <div>
                    <Container fluid={true}>
                        <Row>
                            <Col>
                                <div className="title">
                                    <h3>Movimentar Processo Administrativo</h3>
                                </div>
                                <div className="buttonClose">
                                    <Image className="imageClose"
                                    onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)}
                                    src={fechar}/>
                                </div>
                            </Col>
                        </Row>
                        <Form className="containerForm">
                            <Row>
                                <Col lg="4" xs="12" className="bottom10 hide">
                                    <Form.Label>Sequencial</Form.Label>
                                    <Form.Control
                                    id="sgepprocessoadministrativomovimentacao"
                                    defaultValue={json['sgepprocessoadministrativomovimentacao'] ? json['sgepprocessoadministrativomovimentacao'] : ''}
                                    onChange={(e: any) => this.formEvent.onChange("inteiro", e.target)}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className="isRequired">Data Movimentação</Form.Label>
                                    <Form.Control
                                    id="datamovimentacao"
                                    maxLength={10}
                                    defaultValue={json['datamovimentacao'] ? json['datamovimentacao'] : ''}
                                    onChange={(e: any) => this.formEvent.onChange("date", e.target)}
                                    placeholder="Digite a data da movimentação" 
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className="isRequired">Responsável</Form.Label>
                                    <Select
                                    id="responsavel"
                                    value={this.formEvent.onValueSelect('select', 'responsavel', this.state.professional)}
                                    onChange={(e: any) => this.formEvent.onChange("select", e, "responsavel")}
                                    closeMenuOnSelect={true}
                                    placeholder={"Selecione"}
                                    options={this.state.professional}
                                    isMulti={false}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" className="bottom10">
                                    <Form.Label>Descrição</Form.Label>
                                    <Form.Control
                                    id="descricao"
                                    as="textarea" 
                                    rows="3"
                                    defaultValue={json['descricao'] ? json['descricao'] : ''}
                                    onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                    placeholder="Digite uma descrição" 
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" style={{marginTop: 20}}>
                                    <Button className="buttonSave" type="button" onClick={(e: any) => this.save()} variant="primary">
                                        <Image className="imageSave"
                                        src={salvar}/>
                                        Salvar
                                    </Button>
                                    <Button onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)} className="buttonCancel" variant="link">Cancelar</Button>
                                </Col>
                            </Row>
                        </Form>
                        <ToastContainer />
                    </Container>
                </div>
                <LoaderComponente show={this.state.isLoading} hide={() => this.setState({isLoading: this.state.isLoading})}/>
            </div>
        )
    }

    private setKeyFK() {
        var json = this.state.json as any
        json['sgepprocessoadministrativo'] = this.props.idAdminProcess
        json['datamovimentacao'] = moment(new Date()).format('DD/MM/YYYY')

        this.setState({
            json: json
        })
    }

    private loadProfessional() {
        this.props.viewModel.fetchProfessional().then((rs) => {
            var result = rs as Array<any>
            var array = Array<any>()

            for(var i = 0; i < result.length; i++) {
                var item = result[i]
                array.push({value: item.id, label: item.value, check: false})
            }

            this.setState({
                professional: array
            })
        });
    }

    private save() {
        var json = this.state.json as any
        if(json["datamovimentacao"] == undefined || json["responsavel"] == undefined) {
            this.showFieldsEmpty("Campos obrigatórios não preenchidos!")
            return
        }

        var date = moment(json["datamovimentacao"], "DD/MM/YYYY")
        if(!date.isValid()) {
            this.showFieldsEmpty("Data da movimentação inválida!")
            return
        }

        if(date.diff(new Date()) > 0) {
            this.showFieldsEmpty("Data da movimentação inválida!")
            return
        }

        this.props.viewModel.fetchSave(json).then(() => {
            toast.success("Registro incluído com sucesso!", {
                position: toast.POSITION.BOTTOM_RIGHT
            });

            setTimeout(() => {
                this.props.delegate.tapDimiss(this.props.navigation);
            }, 1000);
        }, e => {
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        })
    }

    private showFieldsEmpty(message: string) {
        toast.error(message, {
            position: toast.POSITION.BOTTOM_RIGHT
        });
    }

    private loadStruct() {
        var json = this.state.json as any 
        json['sgepprocessoadministrativomovimentacao'] = this.props.idPrimary

        this.setState({isLoading: true})
        this.props.viewModel.fetchDataOne(json).then((rs) => {
            var resultado = rs as Array<any>
            if(resultado.length > 0) {
                var result = resultado[0]
                result['datamovimentacao'] = result['datamovimentacao'] ? moment(result['datamovimentacao']).format('DD/MM/YYYY') : ""
                this.setState({
                    isLoading: false,
                    json: result
                })

                return
            }

            this.setState({isLoading: false})
        },e => {
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    }
}